import { BaseWithFollowUsLayout } from "../layouts";
import { Container, NextPageWithLayout } from "@akte-mord/common";
import { serverSideTranslations } from "next-i18next/serverSideTranslations";
import { Typography } from "@mui/material";
import i18nConfig from "../../next-i18next.config";
import React from "react";
import type { GetStaticProps } from "next";

const Delivery: NextPageWithLayout = () => (
  <Container>
    <Typography variant="h1">Versandkosten & Lieferzeiten</Typography>

    <Typography variant="body1" paragraph>
      Alle auf unserer Webseite angezeigten Preise verstehen sich inklusive der gesetzlichen
      Mehrwertsteuer.
    </Typography>

    <Typography variant="body1" paragraph>
      Der Versand von Bestellungen mit einer Lieferadresse innerhalb Deutschlands erfolgt
      versandkostenfrei. Die Lieferzeit beträgt in diesem Fall 3 – 5 Werktage.
    </Typography>

    <Typography variant="body1" paragraph>
      Für Bestellungen mit einer Lieferadresse außerhalb Deutschlands erheben wir eine
      Versandkostenpauschale in Höhe von 4,00 €. Die Lieferzeit für Bestellungen mit einer Lieferadresse
      außerhalb Deutschlands beträgt abweichend 9 Werktage.
    </Typography>
  </Container>
);

Delivery.getLayout = (page) => (
  <BaseWithFollowUsLayout
    description="Versandkosten und Lieferzeiten für Bestellungen in unserem Online-Shop."
    noindex={true}
    title="Versandkosten & Lieferzeiten | Akte Mord® Cold Cases für Zuhause"
  >
    {page}
  </BaseWithFollowUsLayout>
);

export const getStaticProps: GetStaticProps = async ({ locale }) => {
  return {
    props: {
      ...(locale ? await serverSideTranslations(locale, ["c-common"], i18nConfig) : {}),
    },
  };
};

export default Delivery;
